/**
 * Site-wide membership gate: 7-day cookie + localStorage, prefill member fields.
 */
(function () {
  var COOKIE_NAME = 'tbs_membership';
  var STORAGE_KEY = 'tbs_membership';
  var MAX_AGE_SEC = 7 * 24 * 60 * 60;

  function isDesignMode() {
    return (
      (window.Shopify && window.Shopify.designMode) ||
      document.documentElement.classList.contains('shopify-design-mode')
    );
  }

  function parseJson(str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return null;
    }
  }

  function readCookie() {
    var match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
    if (!match) return null;
    return parseJson(decodeURIComponent(match[1]));
  }

  function writeCookie(data) {
    var value = encodeURIComponent(JSON.stringify(data));
    document.cookie =
      COOKIE_NAME + '=' + value + '; path=/; max-age=' + MAX_AGE_SEC + '; SameSite=Lax';
  }

  function isValidMember(data) {
    if (!data || !data.name || !data.phone) return false;
    var ts = Number(data.ts) || 0;
    if (!ts) return false;
    return Date.now() - ts < MAX_AGE_SEC * 1000;
  }

  var TBSMembership = {
    get: function () {
      var data = readCookie();
      if (!isValidMember(data)) {
        data = parseJson(localStorage.getItem(STORAGE_KEY));
      }
      return isValidMember(data) ? data : null;
    },

    set: function (payload) {
      var data = {
        name: String(payload.name || '').trim(),
        phone: String(payload.phone || '').trim(),
        email: String(payload.email || '').trim(),
        ts: Date.now(),
      };
      writeCookie(data);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } catch (e) {
        /* ignore */
      }
      return data;
    },

    isRegistered: function () {
      return !!this.get();
    },

    prefill: function (root) {
      var member = this.get();
      if (!member) return;
      var scope = root && root.querySelector ? root : document;

      var map = {
        name: member.name,
        phone: member.phone,
        email: member.email,
      };

      Object.keys(map).forEach(function (key) {
        var val = map[key];
        if (!val) return;
        scope.querySelectorAll('[data-member-prefill="' + key + '"]').forEach(function (el) {
          if (!el.value) el.value = val;
        });
      });

      scope.querySelectorAll('[data-inquiry-name]').forEach(function (el) {
        if (!el.value && member.name) el.value = member.name;
      });
      scope.querySelectorAll('[data-inquiry-phone]').forEach(function (el) {
        if (!el.value && member.phone) el.value = member.phone;
      });
    },
  };

  window.TBSMembership = TBSMembership;

  function qs(el, sel) {
    return el.querySelector(sel);
  }

  function showGate(gate) {
    gate.hidden = false;
    gate.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('membership-gate-active');
  }

  function hideGate(gate) {
    gate.hidden = true;
    gate.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('membership-gate-active');
  }

  function showStep(gate, step) {
    var formStep = qs(gate, '[data-membership-step="form"]');
    var successStep = qs(gate, '[data-membership-step="success"]');
    if (step === 'success') {
      if (formStep) {
        formStep.classList.add('m:hidden');
        formStep.hidden = true;
      }
      if (successStep) {
        successStep.classList.remove('m:hidden');
        successStep.hidden = false;
      }
    }
  }

  function showError(gate, msg) {
    var err = qs(gate, '[data-membership-error]');
    if (!err) return;
    err.textContent = msg;
    err.hidden = false;
    err.classList.remove('m:hidden');
  }

  function hideError(gate) {
    var err = qs(gate, '[data-membership-error]');
    if (!err) return;
    err.textContent = '';
    err.hidden = true;
    err.classList.add('m:hidden');
  }

  function initGate() {
    if (isDesignMode()) return;

    var gate = document.querySelector('[data-membership-gate]');
    if (!gate) return;

    if (TBSMembership.isRegistered()) {
      TBSMembership.prefill(document);
      hideGate(gate);
      return;
    }

    showGate(gate);

    var form = qs(gate, '[data-membership-form]');
    var continueBtn = qs(gate, '[data-membership-continue]');

    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        hideError(gate);

        var nameEl = qs(form, '[name="name"]');
        var phoneEl = qs(form, '[name="phone"]');
        var emailEl = qs(form, '[name="email"]');
        var name = (nameEl && nameEl.value.trim()) || '';
        var phone = (phoneEl && phoneEl.value.trim()) || '';
        var email = (emailEl && emailEl.value.trim()) || '';

        if (!name || !phone) {
          showError(gate, 'Please enter your name and mobile number.');
          return;
        }

        TBSMembership.set({ name: name, phone: phone, email: email });
        showStep(gate, 'success');
      });
    }

    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        TBSMembership.prefill(document);
        hideGate(gate);
        document.dispatchEvent(new CustomEvent('tbs:membership:registered'));
      });
    }

    gate.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') ev.preventDefault();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGate);
  } else {
    initGate();
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!isDesignMode()) TBSMembership.prefill(document);
  });
})();
